module.exports = __webpack_public_path__ + "img/B9.65420a53.svg";